import { render } from "./MshelConsult.vue?vue&type=template&id=7dffdebe&scoped=true"
import script from "./MshelConsult.vue?vue&type=script&lang=js"
export * from "./MshelConsult.vue?vue&type=script&lang=js"

import "./MshelConsult.vue?vue&type=style&index=0&id=7dffdebe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dffdebe"]])

export default __exports__